import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';

import { AcceptWorkOrder, AcceptWorkOrderVariables } from '../../athena/types/AcceptWorkOrder';

export const ACCEPT_WORK_ORDER = gql`
  mutation AcceptWorkOrder($workOrderID: String) {
    homework {
      acceptWorkOrder(input: { workOrderId: $workOrderID }) {
        id
        state
      }
    }
  }
`;

const useAcceptWorkOrder = () => {
  return useMutation<AcceptWorkOrder, AcceptWorkOrderVariables>(ACCEPT_WORK_ORDER);
};

export default useAcceptWorkOrder;
